module.exports = __webpack_public_path__ + "img/bag_of_core_memories.7ad80486.jpg";